import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack, Text } from '@gluestack-ui/themed';

import { SCORE_BAND_LEGEND_FILL, SCORE_MEDIAN_GRADIENT_END } from './TrendChartChart';

/**
 * Score progression legend (median line + percentile band), above the plot on the left.
 * Swatches use the chart's own blues. The theme series colour is the brand green.
 */
export function TrendChartLegend() {
  const { t } = useTranslation();

  return (
    <HStack space="md" alignItems="center" mt="$1" testID="trend-chart-legend">
      <HStack space="xs" alignItems="center">
        <Box
          width={20}
          height={2}
          borderRadius="$xs"
          style={{ backgroundColor: SCORE_MEDIAN_GRADIENT_END }}
          testID="trend-chart-legend-median-swatch"
        />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.scoreProgression.legendMedian')}
        </Text>
      </HStack>
      <HStack space="xs" alignItems="center">
        <Box
          width={14}
          height={10}
          borderRadius="$xs"
          style={{ backgroundColor: SCORE_BAND_LEGEND_FILL }}
          testID="trend-chart-legend-band-swatch"
        />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.scoreProgression.legendBand')}
        </Text>
      </HStack>
    </HStack>
  );
}
